import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BuildingIcon, ChevronDownIcon, CheckIcon } from 'lucide-react';
interface Company {
  id: number;
  name: string;
  industry: string;
}
const companies: Company[] = [{
  id: 1,
  name: 'PYME Solutions',
  industry: 'Tecnología'
}, {
  id: 2,
  name: 'Retail Express',
  industry: 'Retail'
}, {
  id: 3,
  name: 'Manufacturing Pro',
  industry: 'Manufactura'
}, {
  id: 4,
  name: 'Services Plus',
  industry: 'Servicios'
}];
const CompanySelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(companies[0]);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleSelectCompany = (company: Company) => {
    setSelectedCompany(company);
    setIsOpen(false);
  };
  return <div className="relative" ref={dropdownRef} data-id="element-73">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center space-x-2 px-3 py-2 bg-white border border-gray-200 rounded-lg hover:border-gray-300 transition-colors" data-id="element-74">
        <BuildingIcon size={18} className="text-gray-600" data-id="element-75" />
        <div className="text-left hidden md:block" data-id="element-76">
          <p className="text-sm font-medium text-gray-900" data-id="element-77">
            {selectedCompany.name}
          </p>
          <p className="text-xs text-gray-500" data-id="element-78">{selectedCompany.industry}</p>
        </div>
        <ChevronDownIcon size={16} className={`text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-79" />
      </button>
      <AnimatePresence data-id="element-80">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.2
      }} className="absolute top-full mt-2 left-0 w-72 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden z-50" data-id="element-81">
            <div className="p-2" data-id="element-82">
              <p className="text-xs font-semibold text-gray-500 uppercase px-3 py-2" data-id="element-83">
                Seleccionar empresa
              </p>
              <div className="space-y-1" data-id="element-84">
                {companies.map(company => <button key={company.id} onClick={() => handleSelectCompany(company)} className="w-full flex items-center justify-between px-3 py-2 rounded-md hover:bg-gray-50 transition-colors" data-id="element-85">
                    <div className="flex items-center space-x-3" data-id="element-86">
                      <div className="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center" data-id="element-87">
                        <BuildingIcon size={16} className="text-blue-600" data-id="element-88" />
                      </div>
                      <div className="text-left" data-id="element-89">
                        <p className="text-sm font-medium text-gray-900" data-id="element-90">
                          {company.name}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-91">
                          {company.industry}
                        </p>
                      </div>
                    </div>
                    {selectedCompany.id === company.id && <CheckIcon size={16} className="text-blue-600" data-id="element-92" />}
                  </button>)}
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export default CompanySelector;